export default __webpack_public_path__ + "static/logo-35436f9030ed2489ab312483f1f5a7bb.png";